import { render, staticRenderFns } from "./ShipperPriceEditPopup.vue?vue&type=template&id=0d01f9ee&"
import script from "./ShipperPriceEditPopup.vue?vue&type=script&lang=js&"
export * from "./ShipperPriceEditPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports